import { useEffect, useRef } from "react";
import { FlexibleSelectData } from "./FlexibleSelect/type";

/**
 * 此 Hook 用于获取未经过滤的数据源值。
 * 作用：在选中选项时，确保计算全选和半选状态时不受数据源变化的影响，
 *      保证选中的值始终与初始数据源进行比对。
 */
const useInitialDataSourceValue = (dataSource: FlexibleSelectData[], searchText: string) => {
    const initialDataSourceValueRef = useRef([]);

    useEffect(() => {
        if (searchText !== "") return;

        initialDataSourceValueRef.current = dataSource.map(({ value }) => value);
    }, [dataSource, searchText]);

    return initialDataSourceValueRef.current;
};

export default useInitialDataSourceValue;
